import React from 'react';
import { MonitorPlayIcon, LockIcon } from '@phosphor-icons/react';

const PitchDeck = () => {
    return (
        <div className="flex-1 flex flex-col bg-onyx font-sans h-full overflow-hidden">
            {/* Header */}
            <div className="h-16 border-b border-white/5 flex items-center px-8 justify-between bg-zinc-900/50 backdrop-blur-md">
                <div className="flex items-center gap-3">
                    <div className="p-2 bg-indigo-500/10 rounded-lg">
                        <MonitorPlayIcon className="w-5 h-5 text-indigo-400" />
                    </div>
                    <span className="text-sm font-medium text-white tracking-wide">Pitch Deck Builder</span>
                </div>
                <div className="flex items-center gap-3">
                    <span className="px-2 py-1 bg-white/5 border border-white/5 rounded text-[10px] uppercase tracking-wider text-zinc-500 font-medium">Auto-Save Active</span>
                </div>
            </div>

            <div className="flex-1 flex flex-col items-center justify-center p-8 relative overflow-hidden">
                {/* Background Ambient */}
                <div className="absolute inset-0">
                    <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-indigo-900/10 blur-[120px] rounded-full mix-blend-screen opacity-50" />
                    <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-purple-900/10 blur-[120px] rounded-full mix-blend-screen opacity-50" />
                </div>

                <div className="relative z-10 max-w-2xl text-center space-y-8">
                    <div className="space-y-4">
                        <h1 className="text-4xl md:text-5xl font-light text-white tracking-tight">
                            Pitch Deck Builder <span className="font-semibold text-transparent bg-clip-text bg-gradient-to-r from-indigo-300 to-purple-300">Coming Soon</span>
                        </h1>
                        <p className="text-zinc-400 text-lg font-light leading-relaxed max-w-lg mx-auto">
                            We are building the world's first AI-driven cinematic pitch deck generator. Auto-create financial projections, visual timelines, and box office comparables directly from your storyboard.
                        </p>
                    </div>

                    <div className="pt-12">
                        <div className="inline-flex flex-col items-center gap-4">
                            <span className="px-4 py-2 bg-white/5 border border-white/10 rounded-full text-sm font-medium text-white/60 tracking-wide flex items-center gap-2">
                                <LockIcon className="w-4 h-4" />
                                Release Targeted for Q1 2026
                            </span>
                            <p className="text-zinc-600 text-xs uppercase tracking-widest">Stay Tuned</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PitchDeck;
